module.exports = __webpack_public_path__ + "img/slider (1).5cba1e08.png";